<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination", // 指定分页器容器
          clickable: true // 允许点击分页器切换幻灯片
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          delay: 20000, // 间隔时间，单位毫秒 (ms)
          disableOnInteraction: true, // 用户操作后是否停止自动播放，false表示不停止
          pauseOnMouseEnter: true
          // stopOnLastSlide: false, // (可选) 是否在最后一张停止
        },
        observer: true,
        observeParents: true
      }
    };
  },
  methods: {
    onMouseEnter() {
      this.$refs.mySwiper.$swiper.autoplay.stop();
    },
    onMouseLeave() {
      this.$refs.mySwiper.$swiper.autoplay.start();
    }
  }
};
</script>

<template>
  <div
    :id="item.id"
    :style="{ backgroundImage: `url(${item.module_bg})` }"
    class="module-item"
  >
    <div class="item-box">
      <p class="module-title">{{ item.module_name }}</p>
      <p class="module-desc">{{ item.module_desc }}</p>
      <Swiper
        v-if="item.type === 'swiper'"
        ref="mySwiper"
        :options="swiperOption"
        :pagination="{ clickable: true }"
        :slides-per-view="3"
        :space-between="50"
        style="padding-bottom: 30px"
      >
        <SwiperSlide v-for="(card, index) in item.module_child" :key="index">
          <div
            :style="{ backgroundImage: `url(${card.bg})` }"
            class="swiper-item"
          >
            <div
              :style="{ backgroundImage: card.icon ? `url(${card.icon})` : '' }"
              class="item-icon"
            >
              <img v-if="card.img" :src="card.img" alt="" class="icon-img" />
            </div>
            <div class="item-content">
              <p class="card-title">{{ card.title }}</p>
              <p class="card-desc">{{ card.desc }}</p>
            </div>
          </div>
        </SwiperSlide>
        <template v-if="item.module_child.length > 1">
          <!-- 导航按钮 -->
          <div slot="button-prev" class="swiper-button-prev"></div>
          <div slot="button-next" class="swiper-button-next"></div>
          <!-- 分页器容器 -->
          <div slot="pagination" class="swiper-pagination"></div>
        </template>
      </Swiper>
      <div v-else class="module-content-list">
        <div
          v-for="(card, index) in item.module_child"
          :key="index"
          :style="{ backgroundImage: `url(${card.icon})` }"
          class="list-item"
        >
          <div class="item-content">
            <p class="card-title">{{ card.title }}</p>
            <p class="card-desc">{{ card.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* 可以自定义导航按钮样式 */
.swiper-button-prev {
  left: 20px;
}

.swiper-button-next {
  right: 20px;
}

.swiper-button-prev,
.swiper-button-next {
  color: #fff;
}

/* 分页器基础样式 */
.swiper-pagination {
  bottom: 10px;
}

.module-item {
  width: 100%;
  text-align: center;
  background-size: 100% 100%;
  padding: 80px 0;

  .item-box {
    width: 1100px;
    height: 100%;
    margin: 0 auto;
  }

  .module-title {
    font-size: 30px;
  }

  .module-desc {
    font-size: 16px;
    color: #909296;
    text-align: center;
    width: 90%;
    margin: 16px auto 0;
  }

  .module-content-list {
    display: flex;
    justify-content: space-between;
    margin-top: 34px;
    height: 384px;

    .list-item {
      height: 100%;
      width: 260px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      background-size: 100% 100%;
      transition: all 0.3s;
      color: #fff;

      &:hover {
        transform: scale(1.1);
      }

      .item-content {
        padding: 0 10px;
      }

      .card-title {
        color: #fff;
        font-size: 22px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN, sans-serif;
        font-weight: 500;
      }

      .card-desc {
        width: 158px;
        margin: 10px auto 0;
        font-size: 14px;
        height: 114px;
      }
    }
  }

  .swiper-item {
    width: 100%;
    height: 500px;
    background-size: 100% 100%;
    padding: 90px 96px;
    display: flex;
    box-sizing: border-box;

    .item-icon {
      width: 435px;
      height: 306px;
      flex-shrink: 0;
      background-size: 100% 100%;
      border-radius: 6px;
      overflow: hidden;

      .icon-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .item-content {
      margin-left: 50px;
      padding: 8px 0;
    }

    .card-title {
      margin-bottom: 16px;
      text-align: left;
      color: #fff;
      font-size: 26px;
    }

    .card-desc {
      font-size: 16px;
      color: #fff;
      text-align: left;
      text-indent: 2em;
      line-height: 1.5;
    }
  }
}
</style>
<style>
/* 分页器小圆点样式 */
.swiper-pagination-bullet {
  width: 12px;
  height: 12px;
}
</style>
